module.exports = __webpack_public_path__ + "img/_1.c5310ea3.png";